import { SvgPlay } from '@/lib/shared/icons';
import { staticResource } from '@/lib/shared/utils/resources';
import { sendSocialClick } from '@/lib/shared/utils/send-gtm';

import playBtn from '@/public/icons/playBtn.svg';
import { clsx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import styles from '../Card.module.scss';

interface IProps {
  image: string;
  path: string;
}

export const YouTubeCard = ({ image, path }: IProps) => {
  const href =
    path.startsWith('http://') || path.startsWith('https://')
      ? path
      : `https://www.youtube.com/watch?v=${path}`;

  return (
    <Link
      aria-label="youtube video"
      target={'_blank'}
      href={href}
      onClick={sendSocialClick}
    >
      <div className={clsx(styles.card, styles['card--youtube'])}>
        <Image
          src={staticResource(image)}
          alt={''}
          className={'object-fit-cover'}
          sizes="(max-width: 1624px): 392px, (max-width: 996px) 324px, 343px"
          fill
        />
        <SvgPlay className={styles.card__play} />
        <div className={'playIcon-wrapper'}>
          <Image src={playBtn} alt={''} className={'playIcon'} sizes="100px" />
        </div>
      </div>
    </Link>
  );
};

export default YouTubeCard;
